<div class="card" >
    <!-- Top Section -->
    <div class="top-section">
        <img class="logo" src="../../../assets/stell-logo-white.svg" style="width:160px;" alt="Stellantis-logo" alt="Stellantis Logo" />
        <div *ngIf="currentScreen == 'otp'" class="back-arrow" (click)="flipTheCard()">&#8592; Back</div>
        <!-- <h1>AVIR</h1> -->
        <!-- <label *ngIf="currentScreen === 'login'" class="form-label d-block text-start "
            style="font-size: xx-large;padding-top: 5%;">AVIR</label> -->
            <!-- <span style="flex: 1">
                <img style="width:100px;height: 100px;" src="../../../assets/AVIR_LOGO.png" alt="Stellantis-logo" />
            </span>
        <label  class="form-label d-block text-start"
            style="font-size: large;">Autonomous Vehicle Incident Reporting</label> -->
            <div class="avir-container">
                <!-- AVIR Logo -->
                <img class="avir-logo" style="width:150px;" src="../../../assets/AVIR_LOGO.png" alt="AVIR Logo">
             
                <!-- AVIR Text -->
                <label  class="form-label d-block text-start">
                  Autonomous Vehicle Incident Reporting
                </label>
              </div>
        <!-- <label *ngIf="currentScreen === 'otp'" class="form-label d-block text-start"
            style="font-size: xx-large;padding-top: 5%;">OTP Verification</label> -->
    </div>

    <!-- Bottom Section -->
    <div class="bottom-section">
        <!-- Login Screen -->
        <div *ngIf="currentScreen === 'login'">
            <!-- <label for="mobile-number">Enter registered mobile number:</label> -->
            <div class="mobile-input">
                <span class="country-code">+1</span>
                <input type="tel" maxlength="10" (input)="onInput($event,'number')" id="mobileNumber"
                    class="form-control" placeholder="Enter registered mobile number"
                    [class.is-invalid]="(!mobileNumber || mobileNumber.length < 10) && showErrors" />
            
            </div>
            <div class="consent">
                <label for="consent" class="consent">
                    <input type="checkbox" id="consent-checkbox" name="consent" [(ngModel)]="consentChecked" required>
                    I agree to receive One time passcode (OTP) in SMS from Stellantis NA. Message and data rates may
                    apply.
                </label>

            </div>

            <button class="btn  w-100 mt-3"  (click)="sendOtp()" [ngClass]="{'blocked-cursor': (showSendBtn == false)}"  [disabled]="!consentChecked">Send OTP<div *ngIf="isOtpLoading" class="spinner-border spinner-border-sm text-light" style="margin-left: 5%;" role="status">
                <span class="sr-only">Loading...</span></div></button>
        </div>

        <!-- OTP Screen -->
        <div *ngIf="currentScreen === 'otp'">
            <div class="text-center mt-3">
                <label class="form-label  text-center">Enter 6 digit OTP number</label>
            </div>
            <div class="d-flex justify-content-center gap-2" style="padding-left: 5%;">
                <input type="text" #searchInputRef autocomplete="one-time-code" value="" (input)="onInput($event,'validate')"
                     inputmode="numeric" maxlength="6" pattern="\d{6}">
            </div>
            <div class="text-center mt-3">
                <span *ngIf="timer > 0">Resend OTP in: {{ timer }} seconds</span>
                <span *ngIf="timer === 0" class=" btn-link text-primary" (click)="resendOtp()">
                    Resend OTP
                </span>
            </div>
            <button class="btn  w-100 mt-3" (click)="verifyOtp(otpInputValue)">Verify OTP <div *ngIf="isOtpValidationLoading" class="spinner-border spinner-border-sm text-light" style="margin-left: 5%;" role="status">
                <span class="sr-only">Loading...</span>
              </div></button>
        </div>

        <div *ngIf="showErrors && (mobileNumber.length && mobileNumber.length < 10) && currentScreen === 'login'" class="text-danger mt-1">
            Mobile number must be 10 digits.
        </div>
        <div *ngIf="!mobileNumber && showErrors && currentScreen === 'login'" class="text-danger mt-1">Mobile number is required.</div>
        <div *ngIf="otpInputs.includes('') && showErrors &&currentScreen === 'otp'" class="text-danger mt-2 text-center">All OTP
            fields are
            required.</div>
        <div *ngIf="errmsg.length && currentScreen === 'login'" style="text-align: center;" class="text-danger mt-1">{{errmsg}}</div>
        <div *ngIf="errorverifyOTP.length && currentScreen === 'otp'" style="text-align: center; padding-top: 10%;" class="text-danger mt-1">{{errorverifyOTP}}</div>

        <!-- Footer -->
        <div class="footer">
            &copy; Stellantis. All Rights Reserved. <br><a
                href="https://dealerconnect.chrysler.com/portal/bzcontent/privacy_statements/privacy_notice/Privacy_Notice_en_US.pdf"
                target="_blank" class="privacy-link">Privacy Notice</a>
        </div>
    </div>
       <!-- Toast Message -->
       <div *ngIf="showToast" class="toast-container">
        <div class="toast-message" [class.shred]="triggerShredAnimation">
            {{toastMessage}}
        </div>
    </div>
</div>